import React, { useState } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { buildNewPasswordSchema } from "../../helpers/passwordValidation";
// Icons
import VisibilityIcon from '@mui/icons-material/Visibility';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import toast from "react-hot-toast";
import "./EliteLogin.css";

const PASSWORD_RESET_TOAST_DURATION = 4000;
const FORGOT_PASSWORD_IMAGE = "/register-login-pages/elite-core-forgot-password.png";

function ForgotPasswordTokenValid() {
  const { token, email } = useParams();
  // Password eye check
  const [passwordShown1, setPasswordShown1] = useState(false);
  const [passwordShown2, setPasswordShown2] = useState(false);
  // Toggle eye visibility for passwords
  const togglePasswordVisiblityForPasswordOne = () => {
    setPasswordShown1(passwordShown1 ? false : true);
  };
  const togglePasswordVisiblityForPasswordTwo = () => {
    setPasswordShown2(passwordShown2 ? false : true);
  };
  // Initial values
  const initialValues = {
    password: "",
    password2: "",
  };
  const validationSchema = Yup.object().shape({
    password: buildNewPasswordSchema(),
    password2: Yup.string()
      .oneOf([Yup.ref("password")], "Your passwords must match.")
      .required("You must retype your password."),
  });

  const forgotPassword = async (form, { setSubmitting, resetForm }) => {
    const data = { email: email, token: token, newPassword: form.password };
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/auth/change-a-forgotton-password`,
        data
      );

      if (response?.data?.status === "error") {
        toast.error(response.data.message, {
          duration: PASSWORD_RESET_TOAST_DURATION,
        });
        return;
      }

      toast.success(response?.data?.message || "Password changed successfully.", {
        duration: PASSWORD_RESET_TOAST_DURATION,
      });
      resetForm();
    } catch (e) {
      toast.error(e?.response?.data?.message || "Failed to change password.", {
        duration: PASSWORD_RESET_TOAST_DURATION,
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={forgotPassword}
      validationSchema={validationSchema}
    >
      {({ isSubmitting }) => (
        <Form className="forgotPasswordContainer ec-reset-card">
          <div className="forgotPasswordForm forgotPassword-form-left-side ec-reset-left">
            <div className="loginForm-inner ec-reset-inner">
              <div className="pagination">
                <div className="previousArrow">
                  <Link to="/login"><ArrowBackIcon/> Return to login</Link>
                </div>
              </div>
              <h2 className="forgotPasswordForm-cta-heading">
                <span className="headline">Reset Password</span>
              </h2>
              <p className="forgotPassword-cta-paragraph">
                Create a new password for your Elite Core account.
              </p>

              <label htmlFor="reset-password-field">New password</label>
              <ErrorMessage name="password" component="span" />
              <div className="pass-wrapper">
                <Field
                  autoComplete="new-password"
                  type={passwordShown1 ? "text" : "password"}
                  id="reset-password-field"
                  name="password"
                  placeholder="************"
                />
                <VisibilityIcon onClick={togglePasswordVisiblityForPasswordOne}/>
              </div>

              <label htmlFor="reset-password-confirm-field">Confirm password</label>
              <ErrorMessage name="password2" component="span" />
              <div className="pass-wrapper">
                <Field
                  autoComplete="new-password"
                  type={passwordShown2 ? "text" : "password"}
                  id="reset-password-confirm-field"
                  name="password2"
                  placeholder="************"
                />
                <VisibilityIcon onClick={togglePasswordVisiblityForPasswordTwo}/>
              </div>

              <button disabled={isSubmitting}>
                {isSubmitting ? "Saving..." : "Reset password"}
              </button>
            </div>
          </div>
          <div
            className="forgotPassword-form-right-side ec-reset-photo"
            style={{
              backgroundSize: "cover",
              backgroundPosition: "center center",
              backgroundImage: `url('${FORGOT_PASSWORD_IMAGE}')`,
            }}
          />
        </Form>
      )}
    </Formik>
  );
}

export default ForgotPasswordTokenValid;
